<span class="go-form__required-text" *ngIf="validator">*</span>